import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSplitIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M3 8h1.1A3 3 0 0 0 6.8 6.28l.1-.23a4 4 0 0 1 3.63-2.3H13M2 8h2.1A3 3 0 0 1 6.8 9.72l.1.23a4 4 0 0 0 3.63 2.3H13" }), /* @__PURE__ */ _jsx("path", { d: "m11 1.75 2 2-2 2M11 10.25l2 2-2 2" })]
});
export default SvgSplitIcon;
